import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import * as _ from "lodash";
 
import { Observable, throwError } from "rxjs";
import { tap } from "rxjs/operators";
import {
    CLONE_URL_IGNORE_LIST, COMMON_CONSTANTS, LOADER_IGNORE_LIST, LOGGING_URL_IGNORE_LIST
} from '../common/core/common.constants';
import { SplunkUtilityService } from './splunk-utility.service';
import { ApigeeTokenService } from './apigee-token.service';
import { ErrorMessageService } from './error-message.service';
import { HttpCacheService } from './http-cache.service';
import { LoaderService } from './loader.service';
import { OktaAuthorizationService } from './okta-auth-service';
import { UtilsService } from './utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TechnicalDifficultiesModalComponent } from '../shared/components/technical-difficulties-modal/technical-difficulties-modal.component';
import { WindowServiceService } from "./window-service.service";
import { environment } from "src/environments/environment";
import { HelperUtilityService } from "./helper-utility.service";

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  modalService: NgbModal;
  _apigeeSvc: ApigeeTokenService;
  _errorService: ErrorMessageService;
  _loaderSvc: LoaderService;
  utils: UtilsService;
  splunkSvc: SplunkUtilityService;
  httpCacheService: HttpCacheService;
  oktaAuth: OktaAuthorizationService;
  _windowService: WindowServiceService;
  _helperUtilSvc: HelperUtilityService;
  constructor(
    private injector : Injector
  ) {this.modalService = this.injector.get<NgbModal>(NgbModal);
    this._apigeeSvc = this.injector.get<ApigeeTokenService>(ApigeeTokenService);
    this._errorService = this.injector.get<ErrorMessageService>(ErrorMessageService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.utils = this.injector.get<UtilsService>(UtilsService);
    this.splunkSvc = this.injector.get<SplunkUtilityService>(SplunkUtilityService);
    this.httpCacheService = this.injector.get<HttpCacheService>(HttpCacheService);
    this.oktaAuth = this.injector.get<OktaAuthorizationService>(OktaAuthorizationService);
    this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);}
  ngbModalOptions: NgbModalOptions;
  authReq: HttpRequest<any>;
  counter = 0;
  resObject: any = { errorCode: "", errorMessage: "", errorType: "" };
  requests: [{ [name: string]: Promise<HttpEvent<any>> }] = [{}];
  currRequest: Promise<HttpEvent<any>>;
  isLoggingSvcCall = false;

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this.counter = 0;
    let urlProperties = {};
    if (req.params) {
      urlProperties = req.params.get(COMMON_CONSTANTS.METADATA);
      req.params.delete(COMMON_CONSTANTS.METADATA);
    }
    this.authReq = req;
    if (!this._filterLoaderUrl(this.authReq)) {
      this.counter++;
    }
    if (
      this.counter === 1 &&
      !_.get(urlProperties, COMMON_CONSTANTS.HIDE_LOADER_ICON) &&
      !this._filterLoaderUrl(req)
    ) {
      let urlSplit = req.url.split(/[.\_/?=]/);
      let esimEnabled = environment.ENABLE_ESIM;
      if(!this.checkForBANListingURL()) {
        this._loaderSvc.start();
        if(esimEnabled && urlSplit.includes(COMMON_CONSTANTS.SIM_CHANGE_ELIGIBILITY)){
          this._loaderSvc.stop();
        }
      }
    }
    this.authReq = req.clone({
      params: req.params.delete(COMMON_CONSTANTS.METADATA),
    });

    if (
      this.requests[this.authReq.urlWithParams] &&
      this.authReq.method === COMMON_CONSTANTS.GET_METHOD
    ) {
      this.currRequest = this.requests[this.authReq.urlWithParams];
    }

    if (!this._filterTokenUrl(this.authReq)) {
      this.authReq = this.authReq.clone({
        headers: this._apigeeSvc.setRequestHeaders(this.authReq),
        params: this.authReq.params.delete(COMMON_CONSTANTS.METADATA),
      });
    }

    if(environment.ENABLE_LIGHTHOUSE_IN_AHUB === true){
      this.authReq = this.authReq.clone({
        headers: this.authReq.headers.set('recorded-source', this._helperUtilSvc.getRecordedSourceFromPnp())
      });
    }

    this.requests[this.authReq.urlWithParams] = next.handle(this.authReq);

    return this.requests[this.authReq.urlWithParams].pipe(
      tap(
        (succ) => {
          if (succ instanceof HttpResponse) {
            // code added for the b2b-requestid

            const requestDate = succ.headers.getAll("date");
            if (!(_.isNull(requestDate) || _.isUndefined(requestDate))) {
              this.httpCacheService.putInSessionStoarage(
                COMMON_CONSTANTS.REQUEST_DATE,
                requestDate
              );
            }

            const b2bRequestid = succ.headers.getAll(
              COMMON_CONSTANTS.B2B_REQUESTID
            );
            if (!(_.isNull(b2bRequestid) || _.isUndefined(b2bRequestid))) {
              this.httpCacheService.putInSessionStoarage(
                COMMON_CONSTANTS.B2B_REQUESTID,
                b2bRequestid
              );
            }

            if (!this._filterLoggingUrl(req)) {
              this.splunkSvc.logInSplunk( req, succ);
            }

            if (
              (succ[COMMON_CONSTANTS.BODY] &&
                succ[COMMON_CONSTANTS.BODY].error) ||
              succ[COMMON_CONSTANTS.ERROR_KEY] ||
              succ[COMMON_CONSTANTS.ERROR_MESSAGE]
            ) {
              const errorKey = succ[COMMON_CONSTANTS.BODY].error.errorKey;
              const genericErrorMessage =
                succ[COMMON_CONSTANTS.BODY].error.errorMessage;

              this.resObject.errorCode = errorKey;
              this.resObject.errorMessage = genericErrorMessage;
              this.resObject.errorType = COMMON_CONSTANTS.SUCCESS_ERROR_TYPE;
              if (errorKey || genericErrorMessage) {
                this._errorService.serviceError(this.resObject, true);
                this.splunkSvc.logInSplunk(
                  req,
                  this.resObject
                );

              }
            }

            this.updateLoader(req);
            return succ;
          }
        },
        (error) => {
          let esimEnabled = environment.ENABLE_ESIM;
          if (
            typeof (error.error === "object") &&
            error.error && 
            error.error.errors !== undefined &&
            (error.error.errors.error[0].code ===
              COMMON_CONSTANTS.EXPIRY_TOKEN_ERROR_CODE ||
              error.error.errors.error[0].code ===
                COMMON_CONSTANTS.TOKEN_ERROR_CODE_1001 ||
              error.error.errors.error[0].code ===
                COMMON_CONSTANTS.TOKEN_ERROR_CODE_1008 ||
              error.error.errors.error[0].code ===
                COMMON_CONSTANTS.TOKEN_ERROR_CODE_1014) &&
            (error.error.errors.error[0].systemMessage ===
              COMMON_CONSTANTS.ACCESS_TOKEN_EXPIRED ||
              error.error.errors.error[0].systemMessage ===
                COMMON_CONSTANTS.INVALID_API_KEY ||
              error.error.errors.error[0].systemMessage ===
                COMMON_CONSTANTS.INVALID_ACCESS_TOKEN ||
              error.error.errors.error[0].systemMessage ===
                COMMON_CONSTANTS.INVALID_ACCESS_TOKEN_ISSUER ||
              error.error.errors.error[0].systemMessage
                .toLowerCase()
                .split(" ")
                .includes(COMMON_CONSTANTS.ACCESS || COMMON_CONSTANTS.TOKEN))
          ) {
            const urlSplit = req.url.split(/[.\_/?=]/);
            /** Military apis */
            if (
              urlSplit.includes(COMMON_CONSTANTS.VERIFY_MILITARY_STATUS) ||
              urlSplit.includes(COMMON_CONSTANTS.LOOKUP_AFFILIATION_REF_INFO) ||
              urlSplit.includes(COMMON_CONSTANTS.ENCRYPT_FIELD) ||
              urlSplit.includes(COMMON_CONSTANTS.VERIFY_MILITARY_AFFILIATION) ||
              urlSplit.includes(COMMON_CONSTANTS.VERIFY_DOCUMENTS) ||
              urlSplit.includes(COMMON_CONSTANTS.TOKENS_V6)
            ) {
              this.ngbModalOptions = {
                backdrop: "static",
                keyboard: false,
                centered: true,
                container: '#am-container-custom',
              };
              const errorMsg = error.stack  ? error.stack : error;
              this.splunkSvc.logInSplunk( req, errorMsg, COMMON_CONSTANTS.HIT_A_SNAG);
              this.modalService.open(
                TechnicalDifficultiesModalComponent,
                this.ngbModalOptions
              );
            } else if (
              !urlSplit.includes(COMMON_CONSTANTS.LOOKUP_AFFILIATION_INFO)
            ) {
              this.utils.redirectToOktaPopup();
            }
            setTimeout(() => {
              this.oktaAuth.logOutFromOkta();
              this.httpCacheService.clearSessionStorage();
            }, COMMON_CONSTANTS.DIGITS.FIVE_THOUSAND);
          } else if (
            !isNullOrUndefined(
              error.error && error.error.error && error.error.error[0]
            )
          ) {
            if (!req.url.includes(COMMON_CONSTANTS.SPLUNK_URL)) {
              let serverMsg = COMMON_CONSTANTS.SERVER_ERROR_MSG;
              const urlSplit = req.url.split(/[.\_/?=]/);
              if (
                typeof (error.error === "object") &&
                !isNullOrUndefined(error.error.error[0].userMessage)
              ) {
                serverMsg = error.error.error[0].userMessage;
              }
              /** Military apis */
              if (
                urlSplit.includes(COMMON_CONSTANTS.VERIFY_MILITARY_STATUS) ||
                urlSplit.includes(
                  COMMON_CONSTANTS.LOOKUP_AFFILIATION_REF_INFO
                ) ||
                urlSplit.includes(COMMON_CONSTANTS.ENCRYPT_FIELD) ||
                urlSplit.includes(
                  COMMON_CONSTANTS.VERIFY_MILITARY_AFFILIATION
                ) ||
                urlSplit.includes(COMMON_CONSTANTS.VERIFY_DOCUMENTS) ||
                urlSplit.includes(COMMON_CONSTANTS.TOKENS_V6)
              ) {
                this.ngbModalOptions = {
                  backdrop: "static",
                  keyboard: false,
                  centered: true,
                  container: '#am-container-custom',
                };
                const errorMsg = error.stack  ? error.stack : error;
                this.splunkSvc.logInSplunk(req, errorMsg, COMMON_CONSTANTS.HIT_A_SNAG);
                this.modalService.open(
                  TechnicalDifficultiesModalComponent,
                  this.ngbModalOptions
                );
              } else if(urlSplit.includes(COMMON_CONSTANTS.SIM_CHANGE_API)){
                //Call HandleAPIError method for sim-change api, only when esim flag is off.
                if(!esimEnabled){
                  this.utils.HandleAPIError(serverMsg);
                }
              } else if (
                !urlSplit.includes(COMMON_CONSTANTS.ACCOUNT_ORDER_HISTORY) &&
                !urlSplit.includes(COMMON_CONSTANTS.PLAN_CHANGE) &&
                !urlSplit.includes(COMMON_CONSTANTS.EVALUATE_PROMOTIONS) &&
                !urlSplit.includes(COMMON_CONSTANTS.LOOKUP_AFFILIATION_INFO) &&
                !urlSplit.includes(COMMON_CONSTANTS.PAPERLESS_BILLING) &&
                !urlSplit.includes(COMMON_CONSTANTS.CHANGE_RATE_PLAN) &&
                !urlSplit.includes(COMMON_CONSTANTS.CHANGE_RATEPLAN_SERVICES) &&
                !urlSplit.includes(
                  COMMON_CONSTANTS.PLAN_CHANGE_EFFECTIVE_DATE
                ) &&
                !urlSplit.includes(COMMON_CONSTANTS.SUBSCRIBERS) &&
                !urlSplit.includes(COMMON_CONSTANTS.SERVICEAGGREMNET_API) &&
                !urlSplit.includes(COMMON_CONSTANTS.SUBMIT_RATEPLAN) &&
                !urlSplit.includes(COMMON_CONSTANTS.USER_LIST_API) &&
                !urlSplit.includes(COMMON_CONSTANTS.STATUS_API)&&
                !urlSplit.includes(COMMON_CONSTANTS.CANCEL_SUBSCRIBER_ELIGIBILTY)&&
                !urlSplit.includes(COMMON_CONSTANTS.CANCEL_SUBSCRIBER_API)&&
                !urlSplit.includes(COMMON_CONSTANTS.SUBMIT_CART)
              ) {
                this.utils.HandleAPIError(serverMsg);
              }
            } else {
              if(!this.checkForBANListingURL()) {
                this._loaderSvc.stop();
              }
            }
          }
          this.updateLoader(req, true);
          this.handleError(error, req, next);
        }
      )
    );
  }
  private _filterTokenUrl(req: HttpRequest<any>) {
    for (const routeItem of CLONE_URL_IGNORE_LIST) {
      if (req.urlWithParams.indexOf(routeItem.route) !== -1) {
        return true;
      }
    }
    return false;
  }

  private _filterLoaderUrl(req: HttpRequest<any>) {
    for (const routeItem of LOADER_IGNORE_LIST) {
      if (req.urlWithParams.indexOf(routeItem.route) !== -1) {
        return true;
      }
    }
    return false;
  }
  private _filterLoggingUrl(req: HttpRequest<any>) {
    for (const routeItem of LOGGING_URL_IGNORE_LIST) {
      if (req.urlWithParams.indexOf(routeItem.route) !== -1) {
        return true;
      }
    }
    return false;
  }
  private handleError(
    error: any,
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    const errorWithReqBody = Object.assign(error, { requestBody: req.body });

    if (!this._filterLoggingUrl(req)) {
      this.splunkSvc.logInSplunk(req, errorWithReqBody);
    }
    if (error instanceof HttpErrorResponse) {
      if (error.message) {
        this.resObject.errorCode = error.status;
        this.resObject.errorType = COMMON_CONSTANTS.SERVER_ERROR_TYPE;
        this.resObject.errorMessage = COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
        this._errorService.serverErrorMessgae(this.resObject, true);
      }

      // Retry utility will be written to refreh tokens withh number of tries
      if (
        error.status === 401 ||
        error.status === 400 ||
        error.status === 500
      ) {
        if (error.url.indexOf(COMMON_CONSTANTS.BILLING_ACCT_URL) !== -1) {
          return throwError(COMMON_CONSTANTS.TEMP_ERROR);
        }
      }
    }
    if (error instanceof Response) {
      let errorMessage;
        errorMessage = error.json().then((body) => undefined);
      return throwError(errorMessage);
    }
    return throwError(error || COMMON_CONSTANTS.ERROR_FROM_SERVER);
  }
  private updateLoader(req, isErroredOut?) {
    if (!this._filterLoaderUrl(req) && this.counter > 0) {
      this.counter--;
    }
    if (
      (isErroredOut && !this.isLoggingSvcCall) ||
      (this.counter <= 2 && !this._filterLoaderUrl(req))
    ) {
        if(!this.checkForBANListingURL()) {
          this._loaderSvc.stop();
        }
    }
    this.isLoggingSvcCall = false;

  }

  private checkForBANListingURL(){
    return (this._windowService.location.pathname.includes('/account-management/home') ||
    this._windowService.location.pathname.includes('/account-management/lines') ||
    this._windowService.location.pathname.includes('/account-management/transaction-history'));
  }
}
